import { useEffect, useState } from 'react';
import logo from '../../asset/home-logo.png'
import Contact from '../contact/Contact';
import Service from '../services/Service';

function Home() {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 750);

    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth > 750);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);
  return (
    <>
    <div className='home'>
        <div className='d-flex flex-wrap justify-content-center align-items-center home top'>
          <div className="col-md-6 col-12 d-flex flex-column justify-content-center align-items-center">
          {isMobile && (
              <div className='p d-flex flex-column justify-content-center align-items-center w-75 text-center'>
                  <h1 className='home-title'>ANAB</h1>
                  <p className='sub-title' >Coated & Uncoated Calcium carbonate</p>
                  <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis ipsum vero doloremque impedit quis rem possimus, sapiente nisi nostrum pariatur voluptatum sed cupiditate eius voluptate architecto id officiis facilis repudiandae!</p>
                  <div className='btn-style rounded-5 my-3'><a href="#services" className='text-white text-decoration-none'>Services <i class="ps-2 fa-solid fa-arrow-down"></i></a></div>
              </div>
            )}
          {!isMobile && (
              <div className='p py-5 d-flex flex-column justify-content-center align-items-center w-75 text-center'>
                  <h1 style={{ fontSize:"80px" }} className='home-title'>ANAB</h1>
                  <p className='sub-title' >Coated & Uncoated Calcium carbonate</p>
                  <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Perspiciatis ipsum vero doloremque impedit quis rem possimus, sapiente nisi nostrum pariatur voluptatum sed cupiditate eius voluptate architecto id officiis facilis repudiandae!</p>
                  <div className='btn-style rounded-5 my-3'><a href="#services" className='text-white text-decoration-none'>Services <i class="ps-2 fa-solid fa-arrow-down"></i></a></div>
              </div>
            )}
          </div>
          {isMobile && (<div className="col-md-6 col-12 d-flex justify-content-center align-items-center"> <img src={logo} className='img'  alt="" srcset="" /></div>)}
          {!isMobile && (<div className="pt-3 col-md-6 col-12 d-flex justify-content-center align-items-center"> <img src={logo} className='w-50'  alt="" srcset="" /></div>)}
        </div>
    </div>
    <Service/>
    <Contact/>
    </>
  );
}

export default Home;
